import React from "react";
import {
  Container,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import {
  IMG_DAINASOUL_WALLPAPER as DesktopImage1,
  IMG_DAINASOUL_WALLPAPER_HOODIE as DesktopImage2,
  IMG_DAINASOUL_HOME_PAGE_IMAGE_GRAY as DesktopImage3,
  IMG_DAINASOUL_WALLPAPER as MobileImage1,
  IMG_DAINASOUL_WALLPAPER_HOODIE as MobileImage2,
  IMG_DAINASOUL_HOME_PAGE_IMAGE_GRAY_MOBILE as MobileImage3,
} from "./imageConfig";
import EmailPopup from "./EmailPopup";
import LiquidGlass from "./LiquidGlass";
import { useNavigate, useLocation } from "react-router-dom";

function Home({ hoodieRef }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (ref) => {
    if (location.pathname !== "/" && location.pathname !== "/products") {
      navigate("/");
      setTimeout(() => {
        if (ref.current) {
          window.scrollTo({
            top: ref.current.offsetTop - 80,
            behavior: "smooth",
          });
        }
      }, 100);
    } else {
      if (ref.current) {
        window.scrollTo({
          top: ref.current.offsetTop - 80,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <Box
      sx={{
        height: isMobile ? `calc(100vh - 94px)` : `calc(100vh - 154px)`,
        marginTop: isMobile ? "94px" : "154px",
        display: "flex",
        alignItems: "flex-end", // Align to bottom always
        justifyContent: "center",
        backgroundImage: `url(${isMobile ? MobileImage3 : DesktopImage3})`, // Switch images based on screen size
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden", // Prevent image overflow
        maxWidth: "100%", // Ensure the Box does not exceed the viewport width
        boxSizing: "border-box", // Include padding and border in the element's total width
        width: "100vw", // Ensure the Box takes the full viewport width
        position: "relative",
        paddingBottom: "0rem", // Remove bottom padding always
      }}
    >
      <Container
        sx={{
          paddingX: 4,
          paddingTop: 4,
          paddingBottom: "0rem",
          borderRadius: 2,
          textAlign: "center",
          maxWidth: "100%", // Ensure the Container does not exceed the viewport width
          boxSizing: "border-box", // Include padding and border in the element's total width
          width: "100%", // Ensure the Container takes the full width of the Box
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "flex-end",
        }}
      >
        <EmailPopup />
        {/* <LiquidGlass /> */}
        <Box
          sx={{
            mt: isMobile ? 8 : 12,
            marginBottom: isMobile ? "1rem" : 4,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "#ffffff",
              fontFamily: '"Playfair Display", serif',
              fontSize: isMobile ? "2rem" : "4rem",
              fontWeight: 400,
              mb: isMobile ? 1 : 2,
            }}
          >
            DAINASOUL Classics
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "#ffffff",
              fontFamily: '"Inter", sans-serif',
              fontSize: isMobile ? "0.85rem" : "1rem",
              fontWeight: 300,
              mb: 1,
              letterSpacing: "2px",
              textTransform: "uppercase",
            }}
          >
            Quiet Confidence. Natural Permanence.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#ffffff",
              fontSize: isMobile ? "0.9rem" : "1rem",
              fontWeight: 300,
              maxWidth: "650px",
              margin: "0 auto",
              lineHeight: 1.6,
              mb: isMobile ? 2 : 4,
            }}
          >
            <Box component="span" sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 500 }}>DAINASOUL's</Box> own official fashion line includes exclusive, high-quality classics alongside seasonal limited-edition drops.
          </Typography>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "white",
              color: "black",
              padding: "12px 24px",
              fontSize: "0.875rem",
              transition: "0.1s cubic-bezier(0.5, 0, 0, 1) 0.1s",
              fontWeight: 700,
              borderRadius: 0,
              "&:hover": {
                backgroundColor: "black",
                color: "white",
                fontSize: "0.78rem",
              },
            }}
            onClick={() => navigate('/all-products', { state: { customHeading: "Timeless Classics" } })}
          >
            SHOP THE EDIT
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default Home;
